import React, { useEffect, useState } from 'react';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { TextField } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import Chip from '@mui/material/Chip';


const TagsInput = ({dispatch, input: { ...inputProps }, meta: { touched, error } = {}, isLoading, label, disabled, style, ...props}) => {
  const [tags, setTags] = useState(inputProps.value);
  const [newValue, setNewValue] = useState('');

  const onAdd = () => {
    tags.push(newValue);
    setTags(tags);
    setNewValue('');
  }

  const onChange = (event) => {
    setNewValue(event.target.value);
  }

  const handleDelete = (chipToDelete) => {
    setTags((chips) => chips.filter((chip, key) => key !== chipToDelete));
  }

  useEffect(()=>{
    inputProps.onChange(tags);
  }, [tags, inputProps])

  return(
    <div>

      <div>
        <TextField
              error={!!(touched && error)}
              helperText={touched && error}
              // {...inputProps}
              value={newValue}
              onChange={onChange}
              {...props}
              style={style}
              fullWidth
              focused
              label={label}
              disabled={isLoading || disabled}
              variant="standard"
        />
        <IconButton 
          size='small' 
          // style={{color: (selectedItem&&!!!used&&!!!errorMessage )&&'#0a529f'}} 
          onClick={()=> onAdd()} 
          aria-label="Добавить оператора"
        >
            <ArrowForwardIcon fontSize="small"/>
        </IconButton>
      </div>
      <div>
        {tags.map( (tag,key) => <Chip size="small" key={key+1} label={tag} variant='outlined' onDelete={() => handleDelete(key)}/>)}
      </div>
    </div>
  )
}

const mapStateToProps = (state, props) =>{
  const { fetch } = state;
  return {
      isLoading: !!fetch.loading
  }
}

export default compose(
  connect(mapStateToProps),
)(TagsInput);

